import axios from 'axios';
import { URL_STATS_LIST } from './config';

export async function getStatsList() {
    const result = await axios.get(URL_STATS_LIST);
    return result.data.data;
};

